/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

import pluginFactory from 'taoTests/runner/plugin';

/**
 * This plugin will make sure the anchor relative urls point to the original base URL (fix base html tag behaviour)
 */
export default pluginFactory({
    name: 'anchorBaseUrlConverter',

    init() {
        const testRunner = this.getTestRunner();
        const container = testRunner.getAreaBroker().getContainer();
        const convert = () => {
            let links = container.querySelectorAll("a[href^='#']");

            links.forEach(link => {
                const oldLinkURL = new URL(link.href);
                const newLinkURL = new URL(location);
                newLinkURL.hash = oldLinkURL.hash;
                link.href = newLinkURL.href;

                // neutralize the anchor targets placed inside a hidden container
                const anchors = document.querySelectorAll(`${oldLinkURL.hash}`);
                if (anchors && anchors.length > 1) {
                    anchors.forEach(anchor => {
                        if (anchor.closest('.hidden')) {
                            anchor.removeAttribute('id');
                        }
                    });
                }
            });
        };

        testRunner.on('renderitem', () => convert());
    }
});
